import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Current stima context, attached to every request so AI usage can be linked to a quote.
let _quoteHeaders = { id: null, number: null };
export const setQuoteHeaders = (id, number) => { _quoteHeaders = { id: id ?? null, number: number ?? null }; };

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  if (_quoteHeaders.id) config.headers["X-Quote-Id"] = String(_quoteHeaders.id);
  else delete config.headers["X-Quote-Id"];
  if (_quoteHeaders.number != null) config.headers["X-Quote-Number"] = String(_quoteHeaders.number);
  else delete config.headers["X-Quote-Number"];
  return config;
});

export default api;
